module.exports = __webpack_public_path__ + "img/dgroup_3.22cec3e8.jpg";